import RatingStar from "@components/Icons/RatingStar";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const StarLabel = ({ value }) => (
  <div className="relative inline-block">
    <div className="flex items-center">
      {[1, 2, 3, 4, 5].map((star) => (
        <RatingStar
          width="18px"
          height="18px"
          className={`${
            star <= parseInt(value)
              ? websiteName === "bricostore"
                ? "text-yellow"
                : "text-primary"
              : "text-gray-light"
          }`}
          key={star}
        />
      ))}
    </div>
  </div>
);

export default StarLabel;
